export default __webpack_public_path__ + "static/media/calum.da3dab1a.mp3";